export const aiEvaluationsRouteNames = {
  default: 'ai-evaluations',
  askAiEvaluation: 'ai-evaluations-ask-ai',
}

